import {
  GETFEEREPORTFILE_SUCCESS,
  GETFEEREPORTFILE_FAILED,
  RESET_GETFEEREPORTFILE,
  LOADING_GETFEEREPORTFILE,
  NETWORK_ERROR_GETFEEREPORTFILE,
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetGetFeeReportFile = () => {
  return { type: RESET_GETFEEREPORTFILE };
};

// const getFeeReportFile = (userData, authTokenIs) => async (dispatch) => {
//   dispatch({ type: LOADING_GETFEEREPORTFILE });
//   await partnerServices
//     .post("getFeeReportFile", userData, { headers: { AuthToken: authTokenIs } })
//     .then((res) => {
//       switch (res.data.status) {
//         case "success":
//           dispatch(getFeeReportFileSuccess(res.data));
//           break;
//         default:
//           dispatch(getFeeReportFileFailed(res.data));
//           break;
//       }
//     })
//     .catch((err) => {
//       dispatch({ type: NETWORK_ERROR_GETFEEREPORTFILE, payload: err });
//     });
// };

const getFeeReportFile =
  (userData, authTokenIs, fileType) => async (dispatch) => {  // ✅ added fileType param
    dispatch({ type:  LOADING_GETFEEREPORTFILE });
    await partnerServices
      .post(
        "getFeeReportFile",
        userData,
        {
          headers: { AuthToken: authTokenIs },
          responseType: "blob", // ✅ KEY FIX — treat response as binary
        }
      )
      .then((res) => {
        // ✅ No res.data.status check — blob has no JSON body
        dispatch(getFeeReportFileSuccess({
          status: "success",  // ✅ we set this manually
          blob: res.data,     // ✅ raw binary blob
          fileType: fileType, // ✅ "csv" or "pdf"
        }));
      })
      .catch((err) => {
        // ✅ If server returns error as JSON blob, parse it back
        if (err.response?.data instanceof Blob) {
          const reader = new FileReader();
          reader.onload = () => {
            try {
              const errorJson = JSON.parse(reader.result);
              dispatch(getFeeReportFileFailed(errorJson));
            } catch {
              dispatch(getFeeReportFileFailed({ message: "Unknown error" }));
            }
          };
          reader.readAsText(err.response.data);
        } else {
          dispatch({
            type: NETWORK_ERROR_GETFEEREPORTFILE,
            payload: err,
          });
        }
      });
  };

function getFeeReportFileSuccess(data) {
  return {
    type: GETFEEREPORTFILE_SUCCESS,
    payload: data,
  };
}
function getFeeReportFileFailed(data) {
  return {
    type: GETFEEREPORTFILE_FAILED,
    payload: data,
  };
}

export { resetGetFeeReportFile, getFeeReportFile };
